import classNames from "classnames";

export function SettingsItem(props: {
	children: React.ReactNode;
	active?: boolean;
}) {
	return (
		<div className="flex w-full">
			<div
				className={classNames(
					"w-[0.33rem] min-w-0 flex-shrink-0 border-y border-base-dark",
					{
						"bg-sesh-dark": props.active,
						"bg-base-dark": !props.active,
					}
				)}
			></div>
			<div
				className={classNames(
					"h-full w-full border-y border-l-0 border-r  border-y-base-dark border-r-base-dark bg-base-semidark p-4"
				)}
			>
				{props.children}
			</div>
		</div>
	);
}
